import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "template_estate-compare"
}
const _hoisted_2 = { class: "page-header has-addon inline-addon" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "header-addon" }
const _hoisted_5 = { class: "slider-controls" }
const _hoisted_6 = {
  class: "page-content",
  ref: "scrollContent"
}
const _hoisted_7 = { class: "estate-listing estate-listing--compare" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdCompareShare = _resolveComponent("AdCompareShare")!
  const _component_AdCompareListItem = _resolveComponent("AdCompareListItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('AdCompare.title')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_AdCompareShare, { url: _ctx.compareUrl }, null, 8, ["url"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "slider-prev",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args)))
            }),
            _createElementVNode("span", {
              class: "slider-next",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args)))
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ads, (item, index) => {
          return (_openBlock(), _createBlock(_component_AdCompareListItem, {
            key: item.adId,
            ad: item,
            editable: _ctx.isOwner,
            onRemoved: ($event: any) => (_ctx.onRemoved(index))
          }, null, 8, ["ad", "editable", "onRemoved"]))
        }), 128))
      ])
    ], 512)
  ]))
}